import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_ua\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#mask0_ua)\"><rect width=\"20\" height=\"10\" fill=\"#0057B7\"></rect><rect y=\"10\" width=\"20\" height=\"10\" fill=\"#FFD700\"></rect></g>", 2)
  ])))
}
export default { render: render }